// Imports NOTHING from the rest of the app — this is what breaks the http.ts <-> auth/refresh.ts
// import cycle (both import from here instead of from each other).
export const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '') // '' => same-origin
export const REFRESH_TIMEOUT_MS = 10_000
export const AUTH_PREFIX = '/auth/'
